import { replayScenesList } from "../../src/components/menu/Scenes/replayScenes/scenesReplayData";
import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import { v8AnnChrisSequence } from "../../src/shell/PropertiesDeclarations";
import Question from "../../src/shell/Questions";
import { endReplay } from "../../src/shell/endReplay";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { chris } from "../characters/Chris";
import { mc } from "../characters/MC";
import { empty } from "../characters/empty";
import { doTransition, doWaitImageByTime, isMCCheated, isMCCheatedWithMerry } from "../helpers/helpers";
import { TODMcJoe1 } from "./V2.5";
import { V8AnnChrisHouseAfter } from "./V8";
import { images } from "./images";

const v8 = images.v8;
export const V8AnnChrisHouse = async (): Promise<any> => {
    doTransition(images.v8.V8AnnChrisMC_70);
    chris.talk(`My man! You came!`);
    mc.talk(`Sure, why not? Ann told me you invited me.`);
    chris.talk(`Of course!`);
    // TODO: Chris straighten things if was mean to him


    ImageClass.setImage(images.v8.V8AnnChrisMC_71);
    chris.talk(`Please! Make yourself at home.`);
    chris.talk(`And take off those jeans, I insist! I want you to feel comfortable.`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_70);
    chris.talk(`I can bring you some sweat pants from my closet if you prefer.`);
    mc.talk(`Nah, I'll just stay in my boxers if that's fine by you.`);
    chris.talk(`More than fine!`);


    doWaitImageByTime(images.v8.V8AnnChrisMC_73);
    mc.talk(`So, what have you got planned?`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_72);
    chris.talk(`Nothing much really.`);
    chris.talk(`I barely know you and Ann keeps saying how great of a guy you are, so I asked her to invite you over.`);
    chris.talk(`Let's just sit and chill and see where the night leads us.`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_73);
    mc.talk(`Sounds good to me.`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_74);
    ann.talk(`Hehe! I told you he is great!`);

    ImageClass.setImage(images.v8.V8AnnChrisMC_72);
    chris.talk(`Anything you'd prefer to watch?`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_73);
    mc.talk(`I'm fine with anything.`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_72);
    chris.talk(`Great!`);

    chris.talk(`And of course, don't hesitate to ask for anything.`);
    chris.talk(`Or better yet, just feel free to help yourself if you want.`);

    ImageClass.setImage(images.v8.V8AnnChrisMC_73);
    mc.talk(`Thanks.`);


    return jump(V8AnnChrisHouse_2, "V8AnnChrisHouse_2");
};
export const V8AnnChrisHouse_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v8.V8AnnChrisMC_2);
    ann.talk(`Hehe. I'm so glad you are here!`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_1);
    mc.think(`Alright... Let's see how the night goes...`);

    doTransition(images.v8.V8AnnChrisMC_0, {}, 2);
    mc.think(`I wonder what Ann must be feeling.`);
    mc.think(`She is sitting between two guys she considers to be her boyfriends.`);
    mc.think(`I'd like to think I'm her her true boyfriend and Chris is just the lover she won't mind losing.`);
    mc.think(`But what if I'm wrong?`);
    mc.think(`Chris doesn't strike me as the type of person who'd keep one girlfriend.`);
    if (isMCCheated()) {
        mc.think(`But who am I to talk?`);
        mc.think(`It's not like I've been faithful either...`);
        mc.think(`But it's better not to talk about that now. Let's just focus on the moment.`);
    }

    await mc.setQuestion(new Question({ text: `Should I make a move or see what happens...?`, options: { think: true }, key: `v8AnnChrisHouseHugHer` })
        .option({ title: `Hug Ann`, key: true })
        .option({ title: `Do nothing`, key: false }));


    if (Question.globalAnswers.v8AnnChrisHouseHugHer) {
        return jump(V8AnnChrisHouse_HugAnn, "V8AnnChrisHouse_HugAnn");

    }

    return jump(V8AnnChrisHouse_DoNothing, "V8AnnChrisHouse_DoNothing");
};
export const V8AnnChrisHouse_HugAnn = async (): Promise<any> => {
    mc.think(`She is my girlfriend and I care for her.`);
    doWaitImageByTime(images.v8.V8AnnChrisMC_26);
    await empty.set((properties) => {
        properties.v8AnnChrisMcState = "hugmc";
    });

    mc.think(`This reminds me of when we were at the theater...`);
    if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn) {
        if (Question.globalAnswers.v7AnnChrisMoviesTouchedAnn === false) {
            mc.think(`We sat together and she told me that she wished I had touched her...`);
            mc.think(`I won't miss that opportunity this time.`);
        } else if (Question.globalAnswers.v7AnnChrisMoviesTouchedAnn === true) {
            mc.think(`I touched her while we were at the movies and she loved that.`);
            mc.think(`And we all know why we are here...`);
        }
    } else if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn === false) {
        mc.think(`I let her sit with Chris and he started touching her and she loved it...`);
        mc.think(`But now it's my turn!`);
    }

    await empty.set((properties) => {
        properties.tempString = '...';
    });
    return jump(V8AnnChrisHouse_Sequence, "V8AnnChrisHouse_Sequence");

};
export const V8AnnChrisHouse_Sequence = async (): Promise<any> => {
    await mc.setQuestion(new Question({ text: empty.properties.tempString!, options: { think: true }, key: `v8AnnChrisSequence` })
        .option({ title: `Kiss her`, key: `kiss` })
        .option({ title: `Tell her to swallow`, key: `swallow`, show: empty.properties.v8AnnChrisMcState === "cummc" })
        .option({ title: `Fuck her`, key: `fuck`, hide: mc.properties.v8AnnNightMCCameEarly, show: empty.properties.v8AnnChrisMcState === 'bjmc' || empty.properties.v8AnnChrisMcState === 'hjboth' || (empty.properties.v8AnnChrisMcState === 'bjChris' && mc.properties.v8AnnNightMCParticipated) })
        .option({ title: `Reveal your cock`, key: `revealCock`, hide: mc.properties.v8AnnNightMCCameEarly || !!empty.properties.v8AnnChrisStateCounter.cummc, show: empty.properties.v8AnnChrisMcState === 'hugmc' || empty.properties.v8AnnChrisMcState === 'hugchris' || empty.properties.v8AnnChrisMcState === 'hjchris' })
        .option({ title: `Blowjob ${!mc.properties.v8AnnNightMCParticipated ? '(join in)' : ''}`, key: `bj`, hide: mc.properties.v8AnnNightMCCameEarly || !!empty.properties.v8AnnChrisStateCounter.cummc, show: empty.properties.v8AnnChrisMcState === 'hjboth' || empty.properties.v8AnnChrisMcState === 'hjmc' || (mc.properties.v8AnnNightChrisParticipated && empty.properties.v8AnnChrisMcState === 'bjChris') })
        .option({ title: `Change position`, key: `changePos`, hide: mc.properties.v8AnnNightMCCameEarly, show: empty.properties.v8AnnChrisMcState === "doggymc" || empty.properties.v8AnnChrisMcState === "ridingmc" })
        .option({ title: `Lick her pussy`, key: `lick`, show: empty.properties.v8AnnChrisMcState === "doggychris" || empty.properties.v8AnnChrisMcState === "doggymc" })
        .option({ title: `${!mc.properties.v8AnnNightMCParticipated ? 'Join in' : 'Change with Chris'}`, key: `changeWChris`, hide: mc.properties.v8AnnNightMCCameEarly || !!empty.properties.v8AnnChrisStateCounter.cummc, show: changeWithChrisLogic() })
        .option({ title: `See what Chris will do`, key: `doNothing`, hide: empty.properties.v8AnnChrisMcState === "cummc", show: !mc.properties.v8AnnNightMCParticipated || !changeWithChrisLogic() })
        .option({ title: `cum`, key: `cum`, hide: mc.properties.v8AnnNightMCCameEarly || !mc.properties.v8AnnNightMCParticipated || empty.properties.v8AnnChrisMcState === "cummc" || empty.properties.v8AnnChrisMcState === "cumchris" || empty.properties.v8AnnChrisMcState === "hugmc" || empty.properties.v8AnnChrisMcState === "hugchris" }));



    // mc.talk(`Chris participating - ${!!mc.properties.v8AnnNightChrisParticipated}`);
    // mc.talk(`mc participating - ${!!mc.properties.v8AnnNightMCParticipated}`);
    // mc.talk(`state BEFORE is: ${empty.properties.v8AnnChrisMcState}`);
    let res = null;

    switch (Question.globalAnswers.v8AnnChrisSequence) {
        case "kiss":

            res = await V8AnnChrisHouse_Sequence_Kiss();

            break;
        case "revealCock":
            if (mc.properties.v8AnnNightChrisParticipated) {
                // TODO: render of mc pushing his shorts down
                mc.think(`I can't let Chris have all the fun.`);
                mc.think(`She is my girlfriend after all.`);

                doWaitImageByTime(images.v8.V8AnnChrisMC_30, { wait: true });
                doWaitImageByTime(v8.Anim_V8AnnChrisMCDoubleHJ.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoubleHJ);
                await empty.set((properties) => {
                    properties.tempString = `Ann is grabbing both of our cocks...`;
                    properties.v8AnnChrisMcState = "hjboth";
                });
            } else {
                mc.think(`We all know why we are here...`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_75);
                mc.think(`Better do it now rather than later.`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_76);
                mc.think(`She noticed it.`);
                doWaitImageByTime(v8.Anim_V8AnnChrisMCAnnHJToMC.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnHJToMC);
                mc.think(`And grabbed it immediately.`);
                mc.think(`Damn, I love how her hand feels.`);
                mc.think(`Ann has gotten really good with this.`);
                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "hjmc";
                });

            }

            await mc.set((properties) => {
                properties.v8AnnNightMCParticipated = true;
            });
            break;
        case "bj":

            if (mc.properties.v8AnnNightMCParticipated) {

            } else {

            }
            if (mc.properties.v8AnnNightChrisParticipated) {
                mc.think(`I wanted to feel Ann's mouth so bad.`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_79);
                mc.think(`I guided her towards my cock and she started sucking it.`);
            } else {
                mc.think(`Ann felt how heavy I was breathing and knew exactly what I wanted.`);
                // TODO: animate this (32)
                doWaitImageByTime(images.v8.V8AnnChrisMC_32);
                mc.think(`She leaned forward and started sucking my cock.`);
                mc.think(`Fuck it feels good!`);

            }

            await empty.set((properties) => {
                properties.tempString = ``;
                properties.v8AnnChrisMcState = "bjmc";
            });
            await mc.set((properties) => {
                properties.v8AnnNightMCParticipated = true;
            });
            break;

        case "fuck":
            let restString = '';
            if (mc.properties.v8AnnNightChrisParticipated) {
                mc.think(`I better take the initiative and be the first to fuck her.`);
                mc.talk(`Get on top of me.`);
                doWaitImageByTime(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris);
                restString = ` while Chris was waiting for his turn`;
            } else {
                mc.talk(`Get on top of me.`);
                doWaitImageByTime(v8.Anim_V8AnnChrisAnnRidingMC.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMC);

            }
            mc.think(`Ann took off her clothes and jumped on my cock${restString}.`);
            if (mc.properties.v8AnnNightChrisParticipated) {

            } else {
                mc.think(`It's like she was in her own world.`);
                mc.think(`She kept riding me and didn't even care that Chris is sitting right next to us.`);

            }
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "ridingmc";
            });

            break;
        case "lick":

            if (mc.properties.v8AnnNightChrisParticipated) {
                if (mc.properties.v8AnnNightMCParticipated) {
                    doWaitImageByTime(v8.Anim_V8AnnChrisMCBJToChrisMCLick.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCBJToChrisMCLick, { wait: true });
                    if (empty.properties.v8AnnChrisMcState === "doggychris") {
                        doWaitImageByTime(images.v8.V8AnnChrisMC_62);

                    } else {
                        doWaitImageByTime(v8.Anim_V8AnnChrisMCDoggyChrisBJ.poster);
                        ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoggyChrisBJ);

                    }

                } else {
                    if (!empty.properties.v8AnnChrisSequenceCounter.lick) {
                        if (mc.properties.v8AnnNightMCCameEarly) {
                            mc.think(`I already came but there are other ways I can pleasure her...`);

                        } else {
                            mc.think(`This night is all about making Ann feel good.`);

                        }
                        doWaitImageByTime(v8.Anim_V8AnnChrisMCBJToChrisMCLickWithclothes.poster);
                        ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCBJToChrisMCLickWithclothes, { wait: true });
                        ann.talk(`MMM!!!`);
                        mc.think(`I can only imagine what she must be feeling right now...`);
                        mc.think(`She is so wet...`);

                    } else {
                        if (mc.properties.v8AnnNightMCParticipated) {

                            doWaitImageByTime(v8.Anim_V8AnnChrisMCBJToChrisMCLick.poster);
                            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCBJToChrisMCLick, { wait: true });
                     

                        } else {
                            doWaitImageByTime(v8.Anim_V8AnnChrisMCBJToChrisMCLickWithclothes.poster);
                            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCBJToChrisMCLickWithclothes, { wait: true });
                        }
                    }


                    doWaitImageByTime(images.v8.V8AnnChrisMC_98);

                }

            } else {
                if (!empty.properties.v8AnnChrisSequenceCounter.lick) {
                    ann.talk(`Ah...`);
                    mc.think(`She is so wet...`);
                    mc.think(`I know how to make her feel even better.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_91);
                    ann.talk(`${mc.name}!`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_92);
                    mc.think(`Ann kept moaning while I continued licking her pussy.`);
                    mc.think(`I could tell she was enjoying herself by the way she kept pressing herself against my mouth.`);
                    // TODO: animate 88 
                    doWaitImageByTime(images.v8.V8AnnChrisMC_88);
                } else {
                    if (empty.properties.v8AnnChrisStateCounter.cummc) {
                        mc.think(`Just because Chris is now fucking her doesn't mean I can't help her reach her climax.`);
                    }

                    doWaitImageByTime(images.v8.V8AnnChrisMC_91, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_92, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_88);
                }

            }



            break;
        case "changePos":

            if (empty.properties.v8AnnChrisMcState === "ridingmc") {
                if (mc.properties.v8AnnNightChrisParticipated) {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_64, { wait: true });
                    doWaitImageByTime(v8.Anim_V8AnnChrisMCDoggyChrisBJ.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoggyChrisBJ);

                } else {
                    if (!empty.properties.v8AnnChrisStateCounter.doggymc) {
                        doWaitImageByTime(images.v8.V8AnnChrisMC_87);
                        mc.think(`I started fucking Ann from behind while she laid on Chris' lap.`);
                        mc.think(`He didn't move or say a word so I didn't know if I should feel bad for him during this situation.`);
                        doWaitImageByTime(images.v8.V8AnnChrisMC_88);
                        mc.think(`But the only thing I was focused on was Ann and how amazing her pussy felt.`);

                    } else {
                        doWaitImageByTime(images.v8.V8AnnChrisMC_87, { wait: true });
                        doWaitImageByTime(images.v8.V8AnnChrisMC_88);

                    }

                }
                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "doggymc";
                });
            } else {

                if (mc.properties.v8AnnNightChrisParticipated) {

                    doWaitImageByTime(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris);

                } else {
                    doWaitImageByTime(v8.Anim_V8AnnChrisAnnRidingMC.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMC);

                }
                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "ridingmc";
                });
            }

            break;

        case "changeWChris":

            if (empty.properties.v8AnnChrisMcState === "ridingchris") {

                if (!mc.properties.v8AnnNightMCParticipated) {
                    mc.think(`I can't continue to just sit here and watch.`);
                    mc.talk(`Ann, come here. I need some love.`);
                }

                doWaitImageByTime(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris);
                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "ridingmc";
                });

            } else if (empty.properties.v8AnnChrisMcState === "doggychris") {
                if (!mc.properties.v8AnnNightMCParticipated) {
                    mc.think(`Her head is so close to my dick it turns me on so much.`);
                    mc.think(`I can't continue to just sit here and watch.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_62);
                    mc.think(`Fuck... That's exactly what I needed`);

                } else {
                    doWaitImageByTime(v8.Anim_V8AnnChrisMCDoggyChrisBJ.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoggyChrisBJ);
                    await empty.set((properties) => {
                        properties.v8AnnChrisMcState = "doggymc";
                    });
                }

            } else if (empty.properties.v8AnnChrisMcState === "ridingmc") {
                if (!empty.properties.v8AnnChrisStateCounter.doggychris) {
                    mc.think(`I think it's time for Chris to enjoy Ann's pussy as well...`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_18);
                    mc.think(`Chris grabbed Ann and placed her on his cock...`);
                    mc.think(`Ann looked like she's really enjoying it.`);
                    doWaitImageByTime(images.v8.Anim_V8AnnChrisMCAnnRidingChris.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnRidingChris);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_18, { wait: true });
                    doWaitImageByTime(images.v8.Anim_V8AnnChrisMCAnnRidingChris.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnRidingChris);

                }
                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "ridingchris";
                });
            } else {
                // doggymc
                if (mc.properties.v8AnnNightMCParticipated) {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_63, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_62);
                    // doWaitImageByTime(images.v8.V8AnnChrisMC_64);

                } else {
                    // mc.talk(`TODO: MC not participating  `);

                }
                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "doggychris";
                });
            }


            await mc.set((properties) => {
                properties.v8AnnNightMCParticipated = true;
            });


            // await empty.set((properties) => {
            //     properties.v8AnnChrisMcState = "ridingmc";
            // });

            break;
        case "doNothing":
            res = await V8AnnChrisHouse_Sequence_Nothing();
            break;
        case "swallow":

            mc.talk(`Swallow it.`);
            if (mc.properties.v8AnnNightMCCameEarly || !mc.properties.v8AnnNightChrisParticipated) {
                ImageClass.setImage(images.v8.V8AnnChrisMC_57);
                ann.talk(`Ahh...`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_58);
                ann.talk(`Slurp.`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_59);
                ann.talk(`Hehe.`);
                return jump(V8AnnChrisHouse_MCCCame, "V8AnnChrisHouse_MCCCame");

            } else {
                ImageClass.setImage(images.v8.V8AnnChrisMC_101);
                ann.talk(`Ahh...`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_104);
                ann.talk(`Slurp.`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_105);
                ann.talk(`Hehe.`);



                await V8AnnChrisHouse_Sequence_Nothing();
                return jump(V8AnnChrisHouse_Sequence, "V8AnnChrisHouse_Sequence");

            }

        case "cum":

            if (!empty.properties.v8AnnChrisSequenceCounter.changePos && !empty.properties.v8AnnChrisSequenceCounter.changeWChris && !empty.properties.v8AnnChrisSequenceCounter.fuck) {
                //MC came early
                await mc.set((properties) => {
                    properties.v8AnnNightMCCameEarly = true;
                });

                mc.think(`I know the night is still young but I can't help myself!`);
                if (empty.properties.v8AnnChrisMcState === "ridingchris") {
                    mc.think(`Seeing Ann and Chris fucking really turns me on!`);
                } else {

                    mc.think(`Fuck! It feels so good I'm about to cum already!`);
                }
                mc.talk(`I'm cumming!`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_55);
                mc.talk(`Ah... Fuck!`);

            } else {
                mc.talk(`I'm cumming!`);
                if (mc.properties.v8AnnNightChrisParticipated) {

                    doWaitImageByTime(images.v8.V8AnnChrisMC_100);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_33);
                    mc.think(`Ann turned around and started sucking my cum out.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_55);
                    mc.think(`Ahh...`);


                }

            }


            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "cummc";
                properties.tempString = ` `;
            });
            break;

        default:
            break;
    }
    await empty.set((properties) => {
        if (!(properties.v8AnnChrisSequenceCounter[Question.globalAnswers.v8AnnChrisSequence])) {
            (properties.v8AnnChrisSequenceCounter[Question.globalAnswers.v8AnnChrisSequence]) = 0;
        }
        (properties.v8AnnChrisSequenceCounter[Question.globalAnswers.v8AnnChrisSequence]) += 1;

        if (!(properties.v8AnnChrisStateCounter[empty.properties.v8AnnChrisMcState!])) {
            (properties.v8AnnChrisStateCounter[empty.properties.v8AnnChrisMcState!]) = 0;
        }
        (properties.v8AnnChrisStateCounter[empty.properties.v8AnnChrisMcState!]) += 1;
    });
    // DON'T PUT DIALOGUES HERE IF YOU ARE USING THIS JUMP METHOD, IT FUCKS UP THE ROLLBACK (YOU CAN DO IT ONLY USING A FLAG IN ORDER TO JUMP)
    if (res == null) {

        // mc.talk(`state AFTER is: ${empty.properties.v8AnnChrisMcState}`);
        // mc.talk(`state AFTER counter is: ${JSON.stringify(empty.properties.v8AnnChrisStateCounter)}`);
        return jump(V8AnnChrisHouse_Sequence, "V8AnnChrisHouse_Sequence");
    }


};
export const V8AnnChrisHouse_Sequence_Kiss = async (): Promise<any> => {

    switch (empty.properties.v8AnnChrisMcState) {

        case "hugmcchrishj":
        case "hugmc":

            if (mc.properties.v8AnnNightChrisParticipated) {
                if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes('hugmcchrishj')) {
                    mc.think(`Her mind must be racing right now.`);
                    mc.think(`She's sitting between two guys she considers her boyfriends.`);
                    mc.think(`I already I told her I'm okay with her dating Chris, but now it's my time to prove it.`);
                    ImageClass.setImage(images.v8.V8AnnChrisMC_68);
                    mc.think(`I leaned over and kissed her while she was stroking Chris' cock.`);
                    ImageClass.setImage(images.v8.V8AnnChrisMC_67);
                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_68, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_67);
                }
            } else {

                if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes('hugmc')) {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_69);
                    mc.think(`It feels nice having Ann in my arms.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_26);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_69, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_26);
                }
            }

            break;
        case "hugchris":



            break;
        case "hjboth":
            if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("hjboth")) {
                doWaitImageByTime(images.v8.V8AnnChrisMC_78);
                mc.think(`Kissing Ann while she is holding both our cocks in her hands is definitely a step up...`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_30, { wait: true });
                doWaitImageByTime(v8.Anim_V8AnnChrisMCDoubleHJ.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoubleHJ);

            } else {

                doWaitImageByTime(images.v8.V8AnnChrisMC_78, { wait: true });
                doWaitImageByTime(images.v8.V8AnnChrisMC_30, { wait: true });
                doWaitImageByTime(v8.Anim_V8AnnChrisMCDoubleHJ.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoubleHJ);
            }

            break;
        case "hjchris":

            if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("hjchris")) {
                if (mc.properties.v8AnnNightMCCameEarly) {
                    mc.think(`I know she wanted me here for a reason...`);
                } else {
                    mc.think(`But I do know she wanted me here for a reason...`);
                }
                mc.think(`She wanted to see if I'm supporting and loving her.`);


                if (mc.properties.v8AnnNightMCCameEarly && mc.properties.v8AnnChrisHouseKissedAnn?.find(s => s.includes('mc'))) {
                    //Kissed Ann at some point.
                    mc.think(`I already showed her my love by kissing her. But this time it's different. She is touching someone else...`);
                } else {
                    mc.think(`Kissing her is the best way for me to show her that I'm okay with what's happening and I'm supporting her.`);
                }
                doWaitImageByTime(images.v8.V8AnnChrisMC_22);
                ann.talk(`Mmm...`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_21);
                mc.think(`French kissing Ann while she is stroking Chris' cock is something I never thought I'd do.`);
                mc.think(`I can feel she's getting turned on by that as well.`);


            } else {
                doWaitImageByTime(images.v8.V8AnnChrisMC_22, { wait: true });
                doWaitImageByTime(images.v8.V8AnnChrisMC_21, { wait: true });

            }
            doWaitImageByTime(v8.Anim_V8AnnChrisMCAnnHJToChris.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnHJToChris);
            break;
        case "hjmc":
            // if (empty.properties.v8AnnChrisSequenceCounter.kiss === 1) {
            //     mc.talk(`Kissing Ann for the first time during HJ`);
            // }

            if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("hjmc")) {
                mc.think(`Kissing Ann while she's storking my cock feels amazing.`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_52);
                mc.think(`I can't believe she is doing it when Chris is right there.`);
                ImageClass.setImage(images.v8.V8AnnChrisMC_53);
                mc.think(`It doesn't seem to bother him though.`);
            } else {
                ImageClass.setImage(images.v8.V8AnnChrisMC_52, { wait: true });
                ImageClass.setImage(images.v8.V8AnnChrisMC_53, { wait: true });

            }
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnHJToMC);

            break;
        case "bjChris":
            if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("bjChris")) {

                if (mc.properties.v8AnnChrisHouseKissedAnn?.includes("hjchris")) {
                    mc.think(`She really seemed to like it when I kissed her before.`);
                    mc.think(`I can show my support once again.`);


                } else {
                    mc.think(`Kissing her is me showing her I'm okay with what's happening and I'm supporting her.`);
                }
                // 
                mc.think(`I hesitated for a second but then went for it.`);
                if (mc.properties.v8AnnNightMCParticipated) {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_22);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_24);
                }
                mc.think(`This kiss felt different.`);
                if (mc.properties.v8AnnNightMCParticipated) {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_21);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_25);

                }
                // ImageClass.setImage(images.v8.V8AnnChrisMC_21);
                mc.think(`A second ago she was pleasuring Chris with her mouth and now she is kissing me.`);
                mc.think(`I never thought I'd do something like that, but the timing just felt right.`);

                mc.think(`I can feel Ann's tongue rapidly moving. She is definitely excited and I'm glad she is.`);
                mc.think(`Tonight is about me letting her know that I'm here for her no matter what.`);
                if (mc.properties.v8AnnNightMCParticipated) {
                    doWaitImageByTime(v8.V8AnnChrisMC_15);
                } else {
                    doWaitImageByTime(v8.Anim_V8AnnChrisMCAnnBJToChris.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnBJToChris);

                }
            } else {

                if (mc.properties.v8AnnNightMCParticipated) {
                    // doWaitImageByTime(images.v8.V8AnnChrisMC_80, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_81, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_22, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_15);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_24, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_25, { wait: true });
                    doWaitImageByTime(v8.Anim_V8AnnChrisMCAnnBJToChris.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnBJToChris);
                }
            }

            break;
        case "bjmc":
            if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("bjmc")) {
                doWaitImageByTime(images.v8.V8AnnChrisMC_54);
                mc.think(`I could feel the saliva dripping down all over my cock but I didn't care.`);
                mc.think(`I had an urge to kiss Ann.`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_56);
                ann.talk(`Mmm...`);
            } else {
                doWaitImageByTime(images.v8.V8AnnChrisMC_54, { wait: true });
                doWaitImageByTime(images.v8.V8AnnChrisMC_56, { wait: true });
            }

            if (mc.properties.v8AnnNightChrisParticipated) {
                doWaitImageByTime(images.v8.V8AnnChrisMC_79);

            } else {
                doWaitImageByTime(images.v8.V8AnnChrisMC_32);

            }
            break;
        case "doggychris":
            if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("doggychris")) {
                doWaitImageByTime(images.v8.Anim_V8AnnChrisChrisDoggyMCKissing.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisChrisDoggyMCKissing);
                mc.think(`Ann grabbed my hand and we started kissing while Chris was fucking her from behind.`);
                mc.think(`It was a bit hard to keep our mouths in sync but it was hot regardless.`);

            } else {
                doWaitImageByTime(images.v8.Anim_V8AnnChrisChrisDoggyMCKissing.poster);
                ImageClass.setAnimation(images.v8.Anim_V8AnnChrisChrisDoggyMCKissing, { wait: true });

            }
            if (mc.properties.v8AnnNightMCParticipated) {
                doWaitImageByTime(images.v8.V8AnnChrisMC_62);

            } else {
                doWaitImageByTime(images.v8.V8AnnChrisMC_98);

            }


            break;
        case "doggymc":

            if (mc.properties.v8AnnNightChrisParticipated) {
                if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("doggymc")) {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_95);
                    mc.think(`I pulled Ann towards me for a kiss.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_96);
                    mc.think(`The way her body curved while I was still fucking her from behind was hot as hell.`);
                    mc.think(`Chris was caressing her body while I kissed her and pleasured her from behind.`);
                    doWaitImageByTime(v8.Anim_V8AnnChrisMCDoggyChrisBJ.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoggyChrisBJ);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_95, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_96, { wait: true });
                    doWaitImageByTime(v8.Anim_V8AnnChrisMCDoggyChrisBJ.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoggyChrisBJ);

                }


            } else {
                if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("doggymc")) {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_89);
                    mc.think(`I pulled Ann towards me for a kiss.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_90);
                    mc.think(`The way her body curved while I was still fucking her from behind was hot as hell.`);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_89, { wait: true });
                    doWaitImageByTime(images.v8.V8AnnChrisMC_90, { wait: true });

                }
                doWaitImageByTime(images.v8.V8AnnChrisMC_88);

            }

            break;

        case "ridingchris":
            if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("ridingchris")) {
                mc.think(`The ultimate test.`);
                mc.think(`Kissing her while she's being pleasured by someone else.`);

                doWaitImageByTime(images.v8.V8AnnChrisMC_20);
                ann.talk(`Mmm...`);
                mc.think(`I can feel the passion in this kiss.`);
                mc.think(`Even though she is riding Chris, it feels like all she cares about is me.`);

            } else {
                doWaitImageByTime(images.v8.V8AnnChrisMC_20, { wait: true });
            }
            doWaitImageByTime(images.v8.Anim_V8AnnChrisMCAnnRidingChris.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnRidingChris);

            break;
        case "ridingmc":
            doWaitImageByTime(images.v8.V8AnnChrisMC_84, { wait: true });
            if (mc.properties.v8AnnNightChrisParticipated) {
                if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("ridingmc")) {
                    mc.think(`Ann and I started kissing passionately while she kept riding me as Chris was watching.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_85);
                    mc.think(`I could feel how excited she was by the way she kept moving her body.`);

                    doWaitImageByTime(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_85, { wait: true });

                    doWaitImageByTime(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris);
                }

            } else {
                if (!mc.properties.v8AnnChrisHouseKissedAnn?.includes("ridingmc")) {
                    mc.think(`Ann and I started kissing passionately while she kept riding me.`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_86);
                    mc.think(`I could feel how excited she was by the way she kept moving her body.`);
                    doWaitImageByTime(v8.Anim_V8AnnChrisAnnRidingMC.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMC);

                } else {
                    doWaitImageByTime(images.v8.V8AnnChrisMC_86, { wait: true });
                    doWaitImageByTime(v8.Anim_V8AnnChrisAnnRidingMC.poster);
                    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMC);
                }
            }

            break;
        case "cummc":
            mc.talk(`Ann... Come here.`);


            if (mc.properties.v8AnnNightMCCameEarly || !mc.properties.v8AnnNightChrisParticipated) {
                if (mc.properties.v8AnnNightMCCameEarly) {
                    //mc came early
                }
                doWaitImageByTime(images.v8.V8AnnChrisMC_57);
                mc.think(`Ann opened her mouth and showed me my cum.`);
                mc.think(`But I didn't care. All I wanted is to kiss her no matter what.`);
                await mc.set((properties) => {
                    properties.v8AnnChrisHouseKissedAnn = [...(properties.v8AnnChrisHouseKissedAnn || []), empty.properties.v8AnnChrisMcState!];
                });
                doWaitImageByTime(images.v8.V8AnnChrisMC_61);
                return jump(V8AnnChrisHouse_MCCCame, "V8AnnChrisHouse_MCCCame");

            }
            doWaitImageByTime(images.v8.V8AnnChrisMC_101, { wait: true });
            doWaitImageByTime(images.v8.Anim_V8AnnChrisChrisDoggyMCKissing.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisChrisDoggyMCKissing);

            await mc.set((properties) => {
                properties.v8AnnChrisHouseKissedAnn = [...(properties.v8AnnChrisHouseKissedAnn || []), empty.properties.v8AnnChrisMcState!];
            });
            await V8AnnChrisHouse_Sequence_Nothing();
            return jump(V8AnnChrisHouse_Sequence, "V8AnnChrisHouse_Sequence");
        case "cumchris":
            doWaitImageByTime(images.v8.V8AnnChrisMC_39);
            if (mc.properties.v8AnnChrisHouseKissedAnn?.length) {

            } else {
                mc.think(`I avoided kissing her up to this point.`);
            }

            mc.think(`Ann just finished Chris off but I had a strong urge to kiss her...`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_40);
            mc.think(`I grabbed her hand and she seemed both surprised and confused.`);
            mc.think(`I don't think that she understands what I'm about to do.`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_41);
            ann.talk(`Ahh...`);
            mc.think(`This is it.`);
            mc.think(`I'm really going to kiss my girlfriend while her mouth is still full of Chris' cum?`);
            if (mc.properties.v8AnnChrisHouseKissedAnn?.includes("cummc")) {
                mc.think(`I already shared my own cum with her... Is there really a difference?`);

            }
            if (mc.properties.v8AnnChrisHouseKissedAnn?.includes("ridingchris")) {
                mc.think(`I was completely wrong thinking kissing her while fucking is the ultimate test... Nothing beats this.`);

            }
            doWaitImageByTime(images.v8.V8AnnChrisMC_42);
            ann.talk(`Mmm...`);
            mc.think(`Without saying a word be both started kissing.`);
            mc.think(`The kiss was more intense than usual.`);
            mc.think(`Both Ann and I know it's different.`);
            mc.think(`She keeps moving her tongue rapidly like she wants me to feel and taste every bit of it...`);
            mc.think(`It feels both strange and exciting...`);

            mc.think(`Even without saying a word I can feel that Ann is appreciative of me sharing a very intimate moment with her.`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_43);
            ann.talk(`Wow...`);
            await mc.set((properties) => {
                properties.v8AnnChrisHouseKissedAnn = [...(properties.v8AnnChrisHouseKissedAnn || []), empty.properties.v8AnnChrisMcState!];
            });
            return jump(V8AnnChrisHouse_DoNothing_AfterChrisCum, "V8AnnChrisHouse_DoNothing_AfterChrisCum");

        default:
            break;
    }
    await mc.set((properties) => {
        properties.v8AnnChrisHouseKissedAnn = [...(properties.v8AnnChrisHouseKissedAnn || []), empty.properties.v8AnnChrisMcState!];
    });
};
export const V8AnnChrisHouse_Sequence_Nothing = async (): Promise<any> => {
    if (!mc.properties.v8AnnNightChrisParticipated) {
        await mc.set((properties) => {
            properties.v8AnnNightChrisParticipated = true;
        });

    }
    switch (empty.properties.v8AnnChrisMcState) {
        case "hugchris":

            break;
        case "hugmc":
            mc.think(`I waited a bit to see what Chris would do while Ann was in my arms.`);
            mc.think(`He clearly doesn't want to just watch the movie.`);
            ImageClass.setImage(images.v8.V8AnnChrisMC_66);
            mc.think(`He lowered his pants revealing his cock and Ann was happy to grab it.`);
            ImageClass.setImage(images.v8.V8AnnChrisMC_67);
            mc.think(`I kept holding Ann in my arms while she was stroking Chris' cock.`);
            await mc.set((properties) => {
                properties.v8AnnNightChrisParticipated = true;
            });
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "hugmcchrishj";
            });
            break;

        case "hugmcchrishj":
        case "hjchris":

            doWaitImageByTime(images.v8.V8AnnChrisMC_11);

            if (empty.properties.v8AnnChrisStateCounter.bjChris) {
                //can happen if MC came early and Ann gave Chris a BJ already
                mc.think(`Chris showed Ann she needs to get back into the action.`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_12);

            } else {
                if (mc.properties.v8AnnNightMCCameEarly) {
                    mc.think(`And he's already showing her what he wants...`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_12);
                } else {

                    mc.think(`I waited for a little bit and...`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_11);
                    mc.think(`It looks like Chris wants something more than just Ann's hand...`);
                    doWaitImageByTime(images.v8.V8AnnChrisMC_12);
                }
                mc.think(`Ann obliged and started to suck his cock.`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_13);
                mc.think(`I wonder if that's how they watch movies regularly.`);
                doWaitImageByTime(images.v8.V8AnnChrisMC_14);
            }

            chris.talk(`Yes... Just like that.`, { method: "Low Voice" });
            doWaitImageByTime(images.v8.V8AnnChrisMC_23);
            mc.think(`Chris' moaning got Ann excited and she leaned forward to get into a more comfortable position.`);
            doWaitImageByTime(v8.Anim_V8AnnChrisMCAnnBJToChris.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnBJToChris);
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "bjChris";
                properties.tempString = '...';
            });

            break;
        case "hjboth":

            mc.think(`I wanted to see what Chris would do...`);
            ImageClass.setImage(images.v8.V8AnnChrisMC_82);
            mc.think(`And Chris knew exactly what he wanted.`);
            mc.think(`He guided Ann's head towards his cock. And Ann was ready to oblige.`);
            ImageClass.setImage(images.v8.V8AnnChrisMC_15, { wait: true });
            ImageClass.setImage(images.v8.V8AnnChrisMC_81, { wait: true });
            ImageClass.setImage(images.v8.V8AnnChrisMC_80);

            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "bjChris";
            });
            break;
        case "hjmc":
            ImageClass.setImage(images.v8.V8AnnChrisMC_77, { wait: true });
            ImageClass.setImage(images.v8.V8AnnChrisMC_29, { wait: true });
            ImageClass.setImage(images.v8.V8AnnChrisMC_30, { wait: true });
            doWaitImageByTime(v8.Anim_V8AnnChrisMCDoubleHJ.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoubleHJ);

            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "hjboth";
            });

            break;

        case "bjChris":

            chris.talk(`Remove your clothes I want to fuck you.`);

            doWaitImageByTime(images.v8.V8AnnChrisMC_18);
            mc.think(`Ann took her clothes off and sat on Chris' cock...`);
            if (Question.globalAnswers.v7AnnChrisMoviesSatWithAnn === false) {
                mc.think(`I couldn't help but think that this night is a continuation to what happened in the theater with both of them.`);

            }
            doWaitImageByTime(images.v8.Anim_V8AnnChrisMCAnnRidingChris.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnRidingChris);
            ann.talk(`Ahh...`);
            mc.think(`Who would have believed that this shy girl would reach a point where she willingly fucks someone right there in front of me...`);
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "ridingchris";
            });

            break;
        case "bjmc":
            doWaitImageByTime(images.v8.V8AnnChrisMC_15, { wait: true });
            doWaitImageByTime(images.v8.V8AnnChrisMC_81, { wait: true });
            doWaitImageByTime(images.v8.V8AnnChrisMC_80);
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "bjChris";
            });

            break;

        case "doggymc":
            mc.think(`That was too much for Chris.`);
            doWaitImageByTime(v8.Anim_V8AnnChrisMCDoggyChrisBJ.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCDoggyChrisBJ);
            mc.think(`He took off his pants and put his cock inside of Ann's mouth.`);
            mc.think(`Sweet Ann is now pleasuring Chris while being pleasured by me.`);



            break;
        case "ridingchris":
            doWaitImageByTime(images.v8.V8AnnChrisMC_97);
            mc.think(`Chris took his shorts off and started fucking Ann from behind.`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_98);
            ann.talk(`Fuck...`);
            mc.think(`She's really enjoying it.`);


            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "doggychris";
            });

            break;
        case "doggychris":
        case "cummc":
            chris.talk(`I'm cumming!`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_34);
            mc.think(`She got down on her knees and sucked out all of Chris' cum.`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_35);
            mc.think(`Ann was doing all she could to bring him to climax.`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_37);
            chris.talk(`Ahh...`);

            doWaitImageByTime(images.v8.V8AnnChrisMC_38);
            mc.think(`Ann opened her mouth to show him a mouthful full of his cum.`);
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "cumchris";
                properties.tempString = 'She is getting ready to swallow it...';
            });
            break;
        case "ridingmc":
            doWaitImageByTime(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisAnnRidingMCWithChris);
            chris.talk(`You guys made me fucking horny.`);
            chris.talk(`What about showing me some love?`);
            doWaitImageByTime(images.v8.Anim_V8AnnChrisMCAnnRidingChris.poster);
            ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnRidingChris);
            mc.think(`Ann heard Chris very clearly and jumped on his cock right away.`);
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "ridingchris";
            });


            break;
        case "cumchris":
            doWaitImageByTime(images.v8.V8AnnChrisMC_102, { wait: true });
            ann.talk(`Ahh...`);
            doWaitImageByTime(images.v8.V8AnnChrisMC_103);
            chris.talk(`Good girl.`);
            ann.talk(`Hehe.`);
            return jump(V8AnnChrisHouse_DoNothing_AfterChrisCum, "V8AnnChrisHouse_DoNothing_AfterChrisCum");

        default:
            break;
    }
};
export const V8AnnChrisHouse_MCCCame = async (): Promise<any> => {
    await mc.set((properties) => {
        properties.v8AnnNightMCParticipated = false;
    });
    if (mc.properties.v8AnnNightMCCameEarly) {
        // mc came early
        mc.think(`Fuck, it will take me a while before I can get back into the action...`);
        mc.think(`I guess Ann is in Chris' hands for now.`);
        if (mc.properties.v8AnnNightChrisParticipated) {
            mc.think(`Now he has her all to himself.`);
            if (empty.properties.v8AnnChrisStateCounter.ridingchris) {
                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "ridingchris";
                });

            } else {

                await empty.set((properties) => {
                    properties.v8AnnChrisMcState = "hjchris";
                });
            }
            await V8AnnChrisHouse_Sequence_Nothing();
            return jump(V8AnnChrisHouse_Sequence, "V8AnnChrisHouse_Sequence");
        } else {
            // doWaitImageByTime(images.v8.V8AnnChrisMC_4);
            await empty.set((properties) => {
                properties.v8AnnChrisMcState = "hugchris";
            });

            return jump(V8AnnChrisHouse_DoNothing, "V8AnnChrisHouse_DoNothing");
        }

    }
    // mc came like gigachad
    doWaitImageByTime(v8.V8AnnChrisMC_106);
    ann.talk(`I'm going to wash myself... Be back in a minute!`);
    return jump(V8AnnChrisHouse_AloneWithChris, "V8AnnChrisHouse_AloneWithChris");



};
export const V8AnnChrisHouse_DoNothing = async (): Promise<any> => {
    mc.think(`I'll just stay still and see what happens...`);
    empty.think(`...`);
    doWaitImageByTime(images.v8.V8AnnChrisMC_4);
    if (mc.properties.v8AnnNightMCCameEarly) {
        mc.think(`Chris grabbed Ann and hugged her.`);
        mc.think(`I guess it's his turn now`);
    } else {
        mc.think(`Chris put his arm around Ann.`);
        mc.think(`I can't blame him.`);
    }
    ImageClass.setImage(images.v8.V8AnnChrisMC_3);
    mc.think(`I'll just keep focusing on the movie.`);
    doWaitImageByTime(images.v8.V8AnnChrisMC_5);
    mc.think(`He pulled his pants down revealing his cock...`);
    doWaitImageByTime(images.v8.V8AnnChrisMC_6);
    mc.think(`Ann doesn't seem surprised. It's obviously not the first time seeing it.`);
    doWaitImageByTime(images.v8.V8AnnChrisMC_7);
    mc.think(`She grabbed Chris' cock...`);
    doWaitImageByTime(images.v8.V8AnnChrisMC_10);
    mc.think(`And started stroking it...`);
    doWaitImageByTime(v8.Anim_V8AnnChrisMCAnnHJToChris.poster);
    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAnnHJToChris);
    let s = `She is casually stroking his cock while watching the movie.`;
    if (!mc.properties.v8AnnNightMCCameEarly) {

        mc.think(s);
    }
    await empty.set((properties) => {
        properties.v8AnnChrisMcState = 'hjchris';
        properties.tempString = mc.properties.v8AnnNightMCCameEarly ? s : `I don't know if she wants me to join in or just let her be...`;
    });
    if (!mc.properties.v8AnnNightChrisParticipated) {
        await mc.set((properties) => {
            properties.v8AnnNightChrisParticipated = true;
        });

    }

    return jump(V8AnnChrisHouse_Sequence, "V8AnnChrisHouse_Sequence");
};
export const V8AnnChrisHouse_DoNothing_AfterChrisCum = async (): Promise<any> => {
    doWaitImageByTime(v8.V8AnnChrisMC_106);
    ann.talk(`I'm going to wash myself... Be back in a minute!`);

    return jump(V8AnnChrisHouse_AloneWithChris, "V8AnnChrisHouse_AloneWithChris");
};
export const V8AnnChrisHouse_AloneWithChris = async (): Promise<any> => {
    doTransition(v8.V8AnnChrisMC_107);
    if (mc.properties.v8AnnChrisHouseKissedAnn?.includes("cumchris") || mc.properties.v8AnnChrisHouseKissedAnn?.includes("cummc")) {
        doWaitImageByTime(v8.V8AnnChrisMC_108);
        chris.talk(`You know...`);
        chris.talk(`It takes a real man to do what you just did.`);
        mc.think(`That's a conversation I'd like to avoid...`);
        mc.talk(`Yeah... Thanks.`);
        chris.talk(`I'm honestly serious. I'm not just saying it.`);

        doWaitImageByTime(v8.V8AnnChrisMC_109);
        chris.talk(`I can see that you love her.`);
        if (mc.properties.v8AnnNightChrisParticipated) {
            chris.talk(`Not many guys would be okay with seeing their girl with another man.`);
            chris.talk(`Unless you are telling me she is not your girl.`);
            if (isMCCheated()) {
                if (isMCCheatedWithMerry()) {
                    mc.think(`He knows I've cheated with Merry... But maybe he thinks me and Ann didn't established our relationship back then.`);

                } else {
                    mc.think(`It's not smart telling him I've cheated with other girls.`);
                }

            }
            mc.talk(`She is.`);
            doWaitImageByTime(v8.V8AnnChrisMC_110);
            chris.talk(`Exactly! That's what I mean.`);
            doWaitImageByTime(v8.V8AnnChrisMC_107);
        }
    }


    mc.think(`Ann is taking her sweet time...`);
    doWaitImageByTime(v8.V8AnnChrisMC_108);
    chris.talk(`So, Ann told me you had an interesting day today, but she didn't want to go into specifics.`);
    mc.talk(`What did she say exactly?`);
    chris.talk(`That you helped her practice acting in a very unique way.`);
    await chris.setQuestion(new Question({ text: `As I said, she didn't go into many details.`, options: { think: false }, key: `v8AnnChrisHouseToldChrisAnalDetails` })
        .option({ title: `Tell him in details`, key: true })
        .option({ title: `Don't tell him`, key: false }));


    if (Question.globalAnswers.v8AnnChrisHouseToldChrisAnalDetails) {
        if (Question.globalAnswers.v8AnnCorLibraryBJNerdGuy) {
            mc.talk(`Let's just say it involved her having an anal plug in her ass while giving a blowjob to some nerd guy at the library.`);

        } else {
            mc.talk(`Let's just say it involved her having an anal plug in her ass while licking some nerdy girl's pussy at the library.`);
        }
        doWaitImageByTime(v8.V8AnnChrisMC_110);
        chris.talk(`Hell no! You are fucking with me.`);
        mc.talk(`Nope.`);
        chris.talk(`Damn bro, now you gotta tell me everything.`);
        mc.talk(`Alright, so this is what happened:`);
        doTransition(v8.V8AnnChrisMC_111);

        chris.talk(`Damn! And after all of that you came here?`);
        chris.talk(`That was a very productive day for Ann, don't you say?`);
        mc.talk(`Definitely.`);

        chris.talk(`I bet her ass is tight!`);
        if (Question.globalAnswers.v8AnnCorAfterLibraryFuckHerAss) {
            mc.talk(`It's so tight I couldn't even get my dick inside her...`);
            chris.talk(`It will stretched out in the future, don't you worry!`);
            mc.talk(`I'm betting on it.`);

        } else {
            mc.talk(`I have no idea. I gave her some time to recover from that anal plug.`);
            chris.talk(`She needs more practice and you'll get there!`);
        }
        if (mc.properties.agreeToChrisProposal) {
            if (Question.globalAnswers.v5FuckedMerryAss) {
                chris.talk(`Remember that girl I hooked you up with? Merry?`);


            } else if (!Question.globalAnswers.v5FuckedMerryAss) {
                chris.talk(`Remember that girl I tried hooking you up with? Merry?`);

            }
            doWaitImageByTime(v8.V8AnnChrisMC_109);
            chris.talk(`That girl can take anything up her ass.`);
            if (Question.globalAnswers.v5FuckedMerryAss) {
                mc.talk(`Yeah, I felt it, it was fully wide open.`);
            }
            chris.talk(`You know, it wasn't like that at first.`);
            chris.talk(`It requires a lot of practice.`);
            mc.talk(`Yeah, don't you worry.`);
            doWaitImageByTime(v8.V8AnnChrisMC_111);
            chris.talk(`Haha, you devil!`);

        } else {
            doWaitImageByTime(v8.V8AnnChrisMC_111);
            chris.talk(`I know a girl that can take anything up her ass!`);
            chris.talk(`I'll introduce her to you one day.`);
        }


    } else {
        mc.talk(`Yeah... It's not that interesting.`);
        chris.talk(`Sure.`);

    }


    return jump(V8AnnChrisHouse_FellAsleep, "V8AnnChrisHouse_FellAsleep");
};
export const V8AnnChrisHouse_FellAsleep = async (): Promise<any> => {
    doWaitImageByTime(v8.V8AnnChrisMC_107);
    mc.think(`Where is Ann? I'm getting fucking sleepy...`);
    mc.think(`Fuck I don't think I'll be able to keep my eyes open...`);
    mc.think(`I'll just let them rest till she's back.`);

    // blackscreen
    doWaitImageByTime(images.v2_5.BlackScreen, { duration: 2, wait: 2.5 });
    if (!mc.properties.v8AnnNightChrisParticipated || Question.globalAnswers.V1NtrUnexpected || mc.properties.v8AnnChrisHouseKissedAnn?.includes("cumchris")) {
        if (mc.properties.v8AnnChrisHouseKissedAnn?.includes("cumchris") || mc.properties.v8AnnChrisHouseKissedAnn?.includes("bjChris")) {
            await mc.set((properties) => {
                properties.v8gotLoveYouFromAnn = true;
            });
            ann.talk(`${mc.name}...?`);
            doWaitImageByTime(v8.V8AnnChrisMC_45);
            ann.talk(`You know that I love you right?`);
            mc.talk(`I love you too.`);
            mc.talk(`Are you ready to go?`);
            ann.talk(`In a bit`);
            mc.talk(`Of course... I'll just let me eyes rest.`);
            doWaitImageByTime(v8.V8AnnChrisMC_46);
            if (!mc.properties.v8AnnNightChrisParticipated) {
                mc.think(`I didn't even notice Chris was fucking her.`);
                mc.think(`It's only fair... He didn't get any action at all`);
            } else {
                mc.think(`I didn't even notice Chris was fucking her again.`);

            }

            doWaitImageByTime(images.v2_5.BlackScreen, { duration: 2, wait: 2.5 });
        } else {

        }
        empty.think(`*Clapping noises*`);
        doWaitImageByTime(v8.Anim_V8AnnChrisMCAgainstTheWall.poster);
        ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCAgainstTheWall);
        if (!mc.properties.v8AnnNightChrisParticipated) {
            mc.think(`It's only fair... He didn't get any action at all`);
        } else {
            mc.think(`They are still going at it.`);
        }
        doWaitImageByTime(images.v2_5.BlackScreen, { duration: 2, wait: 2.5 });
    }
    if (Question.globalAnswers.v8AnnChrisHouseToldChrisAnalDetails || Question.globalAnswers.V1NtrUnexpected) {
        ann.talk(`Ouch!`, { method: "Whispering" });
        mc.think(`Huh?`);
        doWaitImageByTime(v8.Anim_V8AnnChrisMCChrisAnal.poster);
        ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCChrisAnal);
        mc.think(`What the fuck?`);
        mc.think(`Is he...`);
        doWaitImageByTime(v8.Anim_V8AnnChrisMCChrisAnalClose.poster);
        ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCChrisAnalClose);
        mc.think(`Fucking her in the ass???`);
        ann.talk(`I can't!`, { method: "Whispering" });
        mc.think(`Or at least trying...`);
        if (Question.globalAnswers.v8AnnChrisHouseToldChrisAnalDetails) {
            mc.think(`That's what I get for telling him every single detail.`);
        } else {
            if (Question.globalAnswers.v8AnnCorAfterLibraryFuckHerAss) {
                mc.think(`Ann must have told him we tried it earlier and failed.`);

            } else {
                mc.think(`Ann must have told him about the anal plug and it gave him ideas...`);

            }
        }
        doWaitImageByTime(images.v2_5.BlackScreen, { duration: 2, wait: 2.5 });
    }
    ImageClass.setImage(v8.V8AnnChrisMC_51.partials.V8AnnChrisMC_51_p_ann_talking, { putParent: true });
    ann.talk(`Good morning!`);
    ImageClass.setImage(v8.V8AnnChrisMC_51);
    chris.talk(`Finally, we've been waiting for you to wake up.`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_51.partials.V8AnnChrisMC_51_p_chris_natural);
    mc.think(`I bet.`);

    ImageClass.setImage(images.v8.V8AnnChrisMC_51.partials.V8AnnChrisMC_51_p_ann_talking);
    ann.talk(`We better get going while it's still dark, I don't want my parents to find out I'm not at home.`);
    ImageClass.setImage(images.v8.V8AnnChrisMC_51.partials.V8AnnChrisMC_51_p_chris_natural, { putParent: true });
    mc.talk(`Alright, let's get going then.`);
    ImageClass.setImage(v8.V8AnnChrisMC_51);
    chris.talk(`Hold on.`);
    chris.talk(`There is a specific way I like to drink my coffee.`);
    doWaitImageByTime(v8.V8AnnChrisMC_112);
    chris.talk(`But I need Ann for that.`);
    ann.talk(`Hehe.`);
    mc.think(`What's that supposed to mean...?`);
    ImageClass.setImage(v8.V8AnnChrisMC_51);
    await chris.setQuestion(new Question({ text: `Do you mind if I'll steal her away for five more minutes?`, options: { think: false }, key: `v8AnnChrisAgreeCoffeeBlowjob` })
        .option({ title: `Sure, go ahead`, key: true })
        .option({ title: `We should really get going`, key: false }));


    if (Question.globalAnswers.v8AnnChrisAgreeCoffeeBlowjob) {
        mc.talk(`Sure, go ahead.`);
        return jump(V8AnnChrisHouse_CoffeeBJ, "V8AnnChrisHouse_CoffeeBJ");

    } else {
        mc.talk(`We should really get going.`);
        chris.talk(`Damn...`);

    }


    return jump(V8AnnChrisHouse_End, "V8AnnChrisHouse_End");
};

export const V8AnnChrisHouse_CoffeeBJ = async (): Promise<any> => {
    doWaitImageByTime(v8.V8AnnChrisMC_112);
    chris.talk(`You know what to do.`);

    doWaitImageByTime(v8.V8AnnChrisMC_113);
    mc.think(`Chris pulled off his towel and sat down on the stool while Ann approached him...`);
    mc.think(`He wasn't kidding... She actually knew what to do.`);
    doWaitImageByTime(v8.V8AnnChrisMC_49);
    mc.think(`She got down on her knees and started sucking Chris' cock...`);
    mc.think(`Is that how he drink his coffee?`);
    doWaitImageByTime(v8.Anim_V8AnnChrisMCChrisCoffeeBJ.poster);
    ImageClass.setAnimation(images.v8.Anim_V8AnnChrisMCChrisCoffeeBJ);
    chris.talk(`*Sip*.`);
    mc.think(`...`);
    doWaitImageByTime(v8.V8AnnChrisMC_114);
    // ImageClass.setImage(v8.V8AnnChrisMC_114, { duration: 22, wait: 22, hideText: true });
    chris.talk(`Coffee's done!`);


    return jump(V8AnnChrisHouse_End, "V8AnnChrisHouse_End");
};
export const V8AnnChrisHouse_End = async (): Promise<any> => {
    doWaitImageByTime(v8.V8AnnChrisMC_51);
    if (Question.globalAnswers.v8AnnChrisAgreeCoffeeBlowjob) {
        chris.talk(`Bro, thanks for coming!`);
    } else {
        chris.talk(`Anyway! Thanks for coming bro, it was fun!`);
    }
    await endReplay(replayScenesList.v8AnnChrisMCThreesome);
    doWaitImageByTime(v8.V8AnnChrisMC_115);
    await chris.setQuestion(new Question({ text: `I hope we can do this again sometime.`, options: { think: false }, key: `v8AnnChrisFistBumpHim` })
        .option({ title: `Fist bump`, key: true })
        .option({ title: `Just leave`, key: false }));


    if (Question.globalAnswers.v8AnnChrisFistBumpHim) {
        doWaitImageByTime(v8.V8AnnChrisMC_116);
        mc.talk(`Sure thing.`);
        chris.talk(`You're the man!`);
    } else {


    }
    return jump(V8AnnChrisHouseAfter, "V8AnnChrisHouseAfter");
};

function changeWithChrisLogic() {
    return (mc.properties.v8AnnNightChrisParticipated &&
        (empty.properties.v8AnnChrisMcState === "doggychris" ||
            empty.properties.v8AnnChrisMcState === "doggymc" ||
            empty.properties.v8AnnChrisMcState === "ridingchris" ||
            empty.properties.v8AnnChrisMcState === "ridingmc"));
}
